import { gql } from '@apollo/client';

export const SUBMIT_PENDING_CLIENT = gql`
  mutation Mutation(
    $onboardingForm: OnboardingForm!
    $userIds: UserIdsInput!
    $hildaId: BigInt!
  ) {
    submitPendingHildaForClient(
      onboardingForm: $onboardingForm
      userIds: $userIds
      hildaId: $hildaId
    ) {
      success
      message
      hilda {
        statusId
        submitted
      }
    }
  }
`;
